<template>
<div>

        <addRoleForm
        v-if="this.addRoleFormDisplay == true"
        v-on:close-add-form="closeAddForm()"
        v-on:added-role="addRoleLocally($event)"
        >
        </addRoleForm>
        <editRoleForm
        v-if="this.editRoleFormDisplay == true"
        :roleToEdit="this.roleToEdit"
        v-on:role-edited="updateRoleLocally($event)"
        v-on:close-edit-form="closeEditForm()"

        > 
        </editRoleForm>

        <deleteRoleForm
        v-if="this.deleteRoleFormDisplay == true"
        :allRoles="this.allRoles"
        :roleToDelete="this.roleToDelete"
        v-on:role-deleted="deleteRoleLocally($event)"
        v-on:close-delete-form="closeDeleteForm()"
        >
        </deleteRoleForm>

        <viewRolePermissions
          v-if="this.viewRoleDisplay == true"
          :roleToView="this.roleToView"
          v-on:close-view-form="toggleViewRolePermissions()"
        > </viewRolePermissions>

<div
    v-if="this.addRoleFormDisplay == false &&
          this.editRoleFormDisplay == false && 
          this.deleteRoleFormDisplay == false &&
          this.viewRoleDisplay == false"
    class="role-card-parent"
>
<el-card
 class="roles-card"
 >

 <h2> Default roles </h2>

  <el-table :data="this.defaultRoles" >

      <el-table-column prop="rolename">
      </el-table-column>

         <el-table-column align="right" >
                  

     <template slot-scope="scope"  >

                    <p style="font-style: italic;
                      display: inline-block;
                      font-size: 12px;
                      margin-right: 15px;"> default </p>


                    <el-dropdown  trigger="click">
                      <el-button v-on:click.stop type="text">
                        <i class="el-icon-s-operation"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item >
                          <el-button 
                          style="color:unset"
                           type="text"
                           @click.native="toggleViewRolePermissions(scope.row)"
                           >
                            <i class="fa fa-edit mt-2"></i>View role
                          </el-button>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                        </template>

          </el-table-column>

  </el-table>
  
  <h2> Custom roles </h2>

<el-table :data="this.customRoles" >


      <el-table-column prop="rolename" >
      </el-table-column>

         <el-table-column align="right" >

<!-- slot scope for template -->
                        <template slot-scope="scope"  >

                    <el-dropdown  trigger="click">
                      <el-button v-on:click.stop type="text">
                        <i class="el-icon-s-operation"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item >
                          <el-button 
                          style="color:unset"
                           type="text"
                           @click.native="toggleEditRoleForm(scope.row)"
                           >
                            <i class="fa fa-edit mt-2"></i>Edit role
                          </el-button>
                        </el-dropdown-item>
                      
                       <el-dropdown-item >
                          <el-button 
                          style="color:unset"
                           type="text"
                           @click.native="toggleDeleteRoleForm(scope.row)"
                           >
                            <i class="fa fa-trash mt-2"></i>Delete role
                          </el-button>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                        </template>
          </el-table-column>

  </el-table>

</el-card>
 <el-button
 style="margin: 20px 0px;"
  type="primary"
  v-if="this.addRoleFormDisplay == false"
  @click.native="toggleAddRoleForm()"
  >Add new role</el-button>


</div>

</div>
</template>

<script>
import fab from "vue-fab";
import addRoleForm from "@/components/roles/createRoleForm.vue"
import EventService from "@/services/EventService.js";
import editRoleForm from "@/components/roles/editRoleForm.vue"
import deleteRoleForm from "@/components/roles/deleteRoleForm.vue"
import viewRolePermissions from "@/components/roles/viewRolePermissions.vue"
import { mapActions } from "vuex";

export default {
  components: {
    fab,
    addRoleForm,
    editRoleForm,
    deleteRoleForm,
    viewRolePermissions
  },
  data(){
      return{
      allRoles: null,
      addRoleFormDisplay: false,
      editRoleFormDisplay: false,
      deleteRoleFormDisplay: false,
      viewRoleDisplay: false,
      idOfCurrentRole: null,
      defaultRoles: null,
      customRoles: null,
      roleToDelete: null,
      roleToEdit: null,
      roleToView: null
      }
  },
  created(){
        EventService.getAllRoles().then( response => {

        this.allRoles = response.data.roles;

     this.defaultRoles = this.allRoles.filter(function (role) {
        return role.customrole == false;
    });

     this.customRoles = this.allRoles.filter(function (role) {
        return role.customrole == true;
    });
})
  },
  mounted(){
        this.newTitle("Roles and permissions");

  },
  methods:{
      ...mapActions(["newTitle"]),

      toggleAddRoleForm(){
     this.addRoleFormDisplay =  !this.addRoleFormDisplay;
      },
        toggleEditRoleForm(currentRole){
          if(currentRole != undefined){
          this.roleToEdit = currentRole;
          this.idOfCurrentRole = currentRole.roleid;
          }
     this.editRoleFormDisplay =  !this.editRoleFormDisplay;
      },
      toggleDeleteRoleForm(roleToDelete){
       this.roleToDelete = roleToDelete;
        this.deleteRoleFormDisplay =  !this.deleteRoleFormDisplay;

      },
      toggleViewRolePermissions(selectedRole){
        if(selectedRole != undefined){
         this.roleToView = selectedRole.roleid;
        }
        this.viewRoleDisplay = !this.viewRoleDisplay;
      },
      closeAddForm(){
        this.toggleAddRoleForm();
      },
      closeEditForm(){
        this.toggleEditRoleForm();
      },
      closeDeleteForm(){
       this.toggleDeleteRoleForm();

      },
      addRoleLocally($event){
        this.customRoles.push($event);
      },
      updateRoleLocally($event){
                this.$set(this.customRoles, this.customRoles.indexOf($event[0]), $event[1]);
      },
      deleteRoleLocally($event){
            this.$delete(this.customRoles, this.customRoles.indexOf($event));
      },
  }
}
</script>

<style scoped>
h2{
  color: rgb(102, 102, 102);
  text-align: center;
  }
 
.role-card-parent{
    width: 50%;
    margin: auto;
    margin-top: 100px;
}
.roles-card{
   height: calc(100vh - 167px);
   overflow-y: scroll;

}
 @media (min-width: 250px) and (max-width: 979px) {
 
 .role-card-parent{
    width: 100%;
   margin-top: 70px;
}
.roles-card{
   height: calc(100vh - 213px);
}
 }
</style>